(ns ui.components.kanban-list.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/KanbanList/styles.json
;; Source commit: 73d362334a9499ba60ca2ca691dfeeca2e202c5d
;; ----------------------------------------------------------------------------

(def kanban-list
  {:root
   {:base
    "tw2-relative tw2-shrink-0 tw2-min-h-0 tw2-overflow-hidden tw2-rounded-card tw2-bg-bg-card-kanban-list tw2-transition-all tw2-duration-200 tw2-ease-out motion-reduce:tw2-transition-none",
    :drop-target
    {:true
     "tw2-outline-kanban-list-drop-outline-width tw2-outline-kanban-list-drop-outline-style tw2-outline-kanban-list-drop-outline-color tw2-outline-offset-kanban-list-drop-outline-offset",
     :false ""},
    :compound-variants [],
    :default-variants {:drop-target false}},
   :header
   {:base
    "tw2-flex tw2-w-0 tw2-min-w-full tw2-shrink-0 tw2-items-center tw2-justify-between",
    :compound-variants [],
    :default-variants {}},
   :title-group
   {:base "tw2-flex tw2-min-w-0 tw2-items-center tw2-gap-kanban-gap",
    :collapsed {:true "tw2-flex-col", :false ""},
    :compound-variants [],
    :default-variants {:collapsed false}},
   :title
   {:base "tw2-text-label-md-strong tw2-text-secondary",
    :collapsed
    {:true "tw2-whitespace-nowrap tw2-writing-mode-vertical-rl",
     :false "tw2-truncate"},
    :compound-variants [],
    :default-variants {:collapsed false}},
   :actions
   {:base "tw2-flex tw2-shrink-0 tw2-items-center tw2-gap-kanban-gap",
    :collapsed {:true "tw2-flex-col", :false ""},
    :compound-variants [],
    :default-variants {:collapsed false}},
   :body
   {:base
    "tw2-flex tw2-min-h-0 tw2-w-full tw2-flex-1 tw2-flex-col tw2-gap-kanban-gap tw2-overflow-y-auto",
    :compound-variants [],
    :default-variants {}},
   :panel
   {:base
    "tw2-absolute tw2-left-0 tw2-top-0 tw2-p-kanban-padding tw2-transition-opacity tw2-duration-200 tw2-ease-out motion-reduce:tw2-delay-0 motion-reduce:tw2-transition-none",
    :active
    {:true "tw2-z-10 tw2-opacity-100 tw2-delay-75",
     :false "tw2-pointer-events-none tw2-opacity-0"},
    :collapsed
    {:true
     "tw2-flex tw2-w-kanban-list-collapsed-width tw2-max-w-kanban-list-collapsed-width tw2-flex-col tw2-items-center tw2-gap-kanban-gap",
     :false
     "tw2-flex tw2-h-full tw2-min-h-0 tw2-w-kanban-list-width tw2-max-w-kanban-list-width tw2-flex-col tw2-gap-kanban-gap"},
    :compound-variants [],
    :default-variants {:active true, :collapsed false}},
   :_meta
   {:tokens
    ["bg-card-kanban-list"
     "kanban-list-collapsed-width"
     "kanban-list-drop-outline-color"
     "kanban-list-drop-outline-offset"
     "kanban-list-drop-outline-style"
     "kanban-list-drop-outline-width"
     "kanban-list-width"
     "label-md-strong-font-size"
     "label-md-strong-font-weight"
     "label-md-strong-line-height"
     "radius-card"
     "spacing-kanban-gap"
     "spacing-kanban-padding"
     "text-secondary"],
    :generated-from "src/components/KanbanList/KanbanList.styles.ts",
    :composes
    [{:slot "count", :component "badge", :variant "secondary"}
     {:slot "collapse", :component "iconButton", :variant "default"}
     {:slot "collapseTooltip", :component "tooltip", :variant "top"}
     {:slot "add", :component "iconButton", :variant "default"}
     {:slot "addTooltip", :component "tooltip", :variant "top"}]}})
